import { render, staticRenderFns } from "./PointPackage.vue?vue&type=template&id=618a3b90&scoped=true&"
import script from "./PointPackage.vue?vue&type=script&lang=js&"
export * from "./PointPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618a3b90",
  null
  
)

export default component.exports